<template>
  <router-view />
</template>
<script>
import { apiGetInfo } from "@/request/api"; // api接口
export default {
  name: "App",
  mounted () {
    // apiGetInfo({}).then((res) => {
    //   if (res.code != 200) {
    //     this.$message({
    //       message: res.msg,
    //       type: "warning",
    //     });
    //   }
    // });
  }
};
</script>
<style>
  html {
    background-color: #e7e7e9;
  }
  a {
    color: #fff !important;
  }
  * {
    padding: 0px;
    margin: 0px;
  }
</style>
<style scoped>
#app {
  /*  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  background: #e7e7e9;
}
</style>



// WEBPACK FOOTER //
// src/App.vue